// React
import React from 'react';

// Componants
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import { ADGMImage } from 'aurora-components';

// Utils
import { keyEmptyCheck } from 'aurora-utils/utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
// styles
import styles from './styles';

function FooterButtons({
  classes,
  nextBtnText,
  disableNextBtn,
  disablePreviousBtn,
  showNextBtnIcon,
  showPreviousBtnIcon,
  handleNext,
  previousBtnText,
  handleBack,
  customClasses,
}) {
  const locale = localStorage.getItem('lang');

  return (
    <div className={classNames(classes.container, customClasses?.container)}>
      <div className={classNames(classes.buttonsHolder, customClasses?.buttonsHolder)}>
        <Button
          className={classNames(classes.btn, classes.previousButton, customClasses?.previousButton, {
            [classes.disabledBtn]: disablePreviousBtn,
            [classes.rotateArrow]: showPreviousBtnIcon && locale === 'ar',
          })}
          onClick={handleBack}
          disabled={disablePreviousBtn}
          // {...(showPreviousBtnIcon && {
          //   startIcon: (
          //     <Hidden xsDown>
          //       <ADGMImage name='PreviousArrow.png' alt='previous-arrow-btn' />
          //     </Hidden>
          //   ),
          // })}
          // startIcon={
          //   <Hidden xsDown>
          //     <ADGMImage name='PreviousArrow.png' alt='previous-arrow-btn' />
          //   </Hidden>
          // }
        >
          {keyEmptyCheck(previousBtnText || 'cancel')}
        </Button>
        <Button
          className={classNames(classes.btn, classes.nextButton, customClasses?.nextButton, {
            [classes.disabledBtn]: disableNextBtn,
            [classes.rotateArrow]: showNextBtnIcon && locale === 'ar',
          })}
          onClick={handleNext}
          disabled={disableNextBtn}
          {...(showNextBtnIcon && {
            endIcon: (
              <Hidden xsDown>
                <ADGMImage name='NextArrow.png' alt='next-arrow-btn' />
              </Hidden>
            ),
          })}
        >
          {keyEmptyCheck(nextBtnText)}
        </Button>
      </div>
    </div>
  );
}

FooterButtons.propTypes = {
  classes: PropTypes.object.isRequired,
  nextBtnText: PropTypes.string,
  previousBtnText: PropTypes.string,
  disableNextBtn: PropTypes.bool,
  disablePreviousBtn: PropTypes.bool,
  showNextBtnIcon: PropTypes.bool,
  showPreviousBtnIcon: PropTypes.bool,
  handleNext: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  customClasses: PropTypes.object,
};

FooterButtons.defaultProps = {
  nextBtnText: 'proceed',
  previousBtnText: 'cancel',
  disableNextBtn: false,
  disablePreviousBtn: false,
  showNextBtnIcon: false,
  showPreviousBtnIcon: false,
  customClasses: {},
};

export default withStyles(styles)(FooterButtons);
